import { QueryClient, useQuery } from '@tanstack/react-query';
import { PromotionApi } from 'api/ApiHelper';
import { promotionsQueryKey } from 'queries/promotions/queryKey';

export const useGetPromotionStatusQuery = (promotionId: number) =>
  useQuery({
    queryKey: promotionsQueryKey.promotion(promotionId),
    queryFn: () => PromotionApi.getPromotion(promotionId),
    gcTime: 0,
  });

export const prefetchPromotionStatusQuery = async (queryClient: QueryClient, promotionId: number) =>
  queryClient.prefetchQuery({
    queryKey: promotionsQueryKey.promotion(promotionId),
    queryFn: () => PromotionApi.getPromotion(promotionId),
  });
